import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const subscriptionsApiSlice = createApi({
  reducerPath: 'subscriptionsApiSlice',
  tagTypes: ['Subscriptions'],
  baseQuery,
  endpoints: (builder) => ({
    getSubscriptions: builder.query({
      query: ({ apiManager, ...params }) => apiManager.get(params),
      providesTags: ['Subscriptions'],
    }),
    createSubscription: builder.mutation({
      query: ({ apiManager, data }) => apiManager.create(data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['Subscriptions'];
      },
    }),
    updateSubscription: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.update(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['Subscriptions'];
      },
    }),
    partialUpdateSubscription: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.partialUpdate(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['Subscriptions'];
      },
    }),
    cancelSubscription: builder.mutation({
      query: ({ apiManager, id }) => apiManager.cancel(id),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['Subscriptions'];
      },
    }),
    resumeSubscription: builder.mutation({
      query: ({ apiManager, id }) => apiManager.resume(id),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['Subscriptions'];
      },
    }),
  }),
});

export const {
  useGetSubscriptionsQuery,
  useCreateSubscriptionMutation,
  useUpdateSubscriptionMutation,
  usePartialUpdateSubscriptionMutation,
  useCancelSubscriptionMutation,
  useResumeSubscriptionMutation,
} = subscriptionsApiSlice;
